<!-- 组件说明 -->
<template>
  <div class="guide_page">
    <div class="content_wrapper">
      <div class="top_wrapper">
        <div class="logo"></div>
        <div class="music"></div>
      </div>
      <div class="shenzhen"></div>
    </div>
  </div>
</template>

<script>
//import x from ''
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
  created() {
    //生命周期 - 创建完成
  },
  destroyed() {
    //生命周期 - 销毁完成
  },
};
</script>

<style lang='scss' scoped>
.guide_page {
  position: relative;
  background-image: url(~@/assets/bg.png);
  background-size: cover;
  background-position: center center;
  width: 100vw;
  height: 100vh;
  padding-top: 20px;
  .content_wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    .top_wrapper {
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: space-between;
      .logo {
        margin-left: 20px;
        background-image: url(~@/assets/pinan_logo.png);
        background-size: cover;
        width: 90px;
        height: 32px;
      }
      .music {
        margin-right: 20px;
        background-image: url(~@/assets/music_btn.png);
        background-size: cover;
        width: 30px;
        height: 30px;
      }
    }
    .shenzhen {
      position: absolute;
      bottom: 40px;
      background-image: url(~@/assets/shenzhen.png);
      background-size: cover;
      width: 288px;
      height: 91px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/GuidePage.vue